
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ActivateCardLandingPage } from "./ActivateCardLandingPage";
import { ActivateCardSigning } from "./ActivateCardSigning";
import { ActivateCardStore } from "./ActivateCardStore";
import { ActivateCardSuccess } from "./ActivateCardSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class ActivateCardContainer extends React.Component<IProps, {}> {
    store: ActivateCardStore;

    constructor(props: any) {
        super(props);
        this.store = new ActivateCardStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("activateCard.document.title");

        return (
            <div>
                <Route exact path={this.props.match.path} render={this.withStore(ActivateCardLandingPage)} />
                <Route path={this.props.match.path + "/signing"} render={this.withStore(ActivateCardSigning)} />
                <Route path={this.props.match.path + "/success"} render={this.withStore(ActivateCardSuccess)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/activateCard/ActivateCardContainer.tsx